import React, { useEffect, useState } from 'react';
import Lottie from "lottie-react";
import animationData from "../assets/thFRz9L9zW.json";
import { motion } from "framer-motion";
import { TypeAnimation } from "react-type-animation";

import JobCard from './JobCard';
import ApplicationForm from './ApplicationForm'; // Make sure this component exists

import wordpressLogo from '../assets/logos/wordpress1.png';
import shopifyLogo from '../assets/logos/shopify.png';
import fullstackIcon from "../assets/logos/data.png";
import graphicsIcon from "../assets/logos/graphic-designer.png";
import marketingIcon from "../assets/logos/startup_6560994.png";
import SEO from '../components/SEO';

const jobs = [
  {
    id: 1,
    logo: wordpressLogo,
    title: "WordPress Developer",
    experience: "0 – 5",
    bgColor: "rgba(0, 178, 216, 0.2)",
  },
  {
    id: 2,
    logo: shopifyLogo,
    title: "Shopify Developer",
    experience: "0 – 5",
    bgColor: "rgba(60, 179, 113, 0.2)",
  },
  {
    id: 3,
    logo: fullstackIcon,
    title: "Full Stack/PHP Developer",
    experience: "0 – 5",
    bgColor: "rgba(0, 123, 154, 0.2)",
  },
  {
    id: 4,
    logo: graphicsIcon,
    title: "Graphics Designer",
    experience: "0 – 5",
    bgColor: "rgba(192, 144, 96, 0.2)",
  },
  {
    id: 5,
    logo: marketingIcon,
    title: "Digital Marketing",
    experience: "0 – 5",
    bgColor: "rgba(255, 99, 132, 0.2)",
  },
];

const Career = () => {
  const [showForm, setShowForm] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleApply = (jobTitle) => {
    setSelectedJob(jobTitle);
    setShowForm(true);
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  return (
    <div>
      <SEO
        title="Career Opportunities | Lavanya Infotech"
        description="Explore exciting career opportunities at Lavanya Infotech. Join our innovative team and build a future in technology, design, and digital growth."
      />

      {/* Header Section */}
      <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between px-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="w-full md:w-7/12 text-center md:text-left"
        >
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight space-y-3">
            <div>
              <span className="text-[#e5989b]">Build</span>{" "}
              <span className="text-white">Your</span>{" "}
              <span className="text-[#68a691]">Career</span>{" "}
              <span className="text-white">With</span>
            </div>
            <TypeAnimation
              className="text-[#f6f4d2] block"
              sequence={[
                "Web Development", 2000,
                "Graphics Designer", 2000,
                "Digital Marketing", 2000,
                "Shopify Store", 2000
              ]}
              wrapper="span"
              speed={50}
              repeat={Infinity}
              cursor={false}
            />
          </h1>
        </motion.div>

        <div className="w-full md:w-5/12 flex justify-center md:justify-end mt-10 md:mt-0">
          <Lottie
            animationData={animationData}
            loop
            autoplay
            className="w-[300px] sm:w-[400px] md:w-[450px] lg:w-[500px]"
          />
        </div>
      </div>

      {/* Description Section */}
      <div className='pt-10'>
        <div className="content py-10">
          <h1 className="title font-poppins text-2xl sm:text-3xl text-center font-bold">
            See What People Are Saying
            <div className="aurora">
              <div className="aurora__item"></div>
              <div className="aurora__item"></div>
              <div className="aurora__item"></div>
              <div className="aurora__item"></div>
            </div>
          </h1>
          <p className="px-6 text-lg text-center pt-5">
            Become a part of the passionate team at Lavanya Infotech,<br />
            where innovation drives growth and<br />
            excellence is a standard.
          </p>
        </div>
      </div>

      <div className="w-full pt-5 pb-5">
        <hr className="border-t border-white opacity-200" />
      </div>

      {/* Job Cards Section */}
      <div className="bg-black px-4 xyz1 sm:px-6 md:px-8 py-12">
        {/* First Row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {jobs.slice(0, 3).map((job) => (
            <JobCard
              key={job.id}
              logo={job.logo}
              title={job.title}
              type="Full Time"
              experience={job.experience}
              bgColor={job.bgColor}
              onApply={() => handleApply(job.title)}
            />
          ))}
        </div>

        {/* Second Row with offset styling */}
        <div className="grid grid-cols-1 xyz pt-24 sm:grid-cols-2 lg:grid-cols-2 gap-8 mt-[-40px] lg:mt-[-60px] lg:px-16">
          {jobs.slice(3).map((job) => (
            <JobCard
              key={job.id}
              logo={job.logo}
              title={job.title}
              type="Full Time"
              experience={job.experience}
              bgColor={job.bgColor}
              onApply={() => handleApply(job.title)}
            />
          ))}
        </div>
      </div>

      {/* Form Section (shown after Apply click) */}
      {showForm && (
        <div className="mt-10 px-4 sm:px-8 max-w-6xl mx-auto">
          <ApplicationForm selectedJob={selectedJob} />
        </div>
      )}

      <div className="w-full pt-5 pb-5">
        <hr className="border-t border-white opacity-200" />
      </div>
    </div>
  );
};

export default Career;
